import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, prop } from "ramda";

export const ADD_MATERIAL = "POOL@MATERIAL::ADD";
export const ADD_MATERIAL_MULTIPLE = "POOL@MATERIAL::ADD_MULTIPLE";

export const addMaterial = createAction(ADD_MATERIAL);
export const addAllMaterials = createAction(ADD_MATERIAL_MULTIPLE);

const getMaterials = path(["application", "materials"]);

export const selectMaterials = createSelector(
  getMaterials,
  prop("materialPool")
);

const initialState = () => [];

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case ADD_MATERIAL:
      return [...state, action.payload];
    case ADD_MATERIAL_MULTIPLE:
      return [...state, ...action.payload];
    default:
      return state;
  }
}
